import { render } from "./SmallRightColumn.vue?vue&type=template&id=417edee5"
import script from "./SmallRightColumn.vue?vue&type=script&lang=js"
export * from "./SmallRightColumn.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__